import { render, staticRenderFns } from "./AllClaims.vue?vue&type=template&id=d055cdb4&scoped=true"
import script from "./AllClaims.vue?vue&type=script&lang=js"
export * from "./AllClaims.vue?vue&type=script&lang=js"
import style0 from "./AllClaims.vue?vue&type=style&index=0&id=d055cdb4&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d055cdb4",
  null
  
)

export default component.exports